import { UserRole } from "./user-role.model";
import { EntityBase } from "./entity-base.model";
import { UserBranch } from "./user-branch.model";
export class User extends EntityBase {
  public UserName: string;
  public Email: string;
  public PhoneNumber: string;
  public IsEnabled: boolean;
  public Roles: UserRole[];
  public AccessFailedCount: number;
  public LockoutEnd?: Date;
  public LockoutEnabled: boolean;
  public EmailConfirmed: boolean;
  public DisplayName: string;
  public Configuration: string;
  public NewPassword: string;
  public ConfirmPassword: string;
  public LastLoggedInDateTime?: string;
  public Branches: UserBranch[];
  public CurrentBranchId: number;
  public SerialNumber: string;
  public PasswordHash: string;
  public HasSMS: boolean;
  public SettleBySelf: boolean;
  public RialDiscount: number;
  public PercentDiscount: number;
  public ProtelCodez: number;
  public PreventChangeClear: boolean;
}
